module.exports = __webpack_public_path__ + "img/user.4cef5976.svg";